import $api from "../../../../services/axiosService";
import {getRequestsForRescheduleAction} from "../getRequestsForReschedule.action";

export const getRequestsForRescheduleThunkAction = (data) => async (dispatch) => {
    try {
        const response = await $api(`v1/leaverequest/leaves/reschedulable/${data.option}`);
        dispatch(getRequestsForRescheduleAction(response.data));
    } catch (error) {
        dispatch(getRequestsForRescheduleAction());
        // console.log("ERROR WHILE GETTING REQUESTS FOR RESCHEDULE: ", error.response)
    }
};
